import {
  CHECK_ALREADY_ANSWERED,
  CHECK_ALREADY_ANSWERED_CLEAR,
  CHECK_ALREADY_ANSWERED_ERROR,
  CHECK_ALREADY_ANSWERED_SUCCESS,
  CHECK_ANSWER,
  CHECK_ANSWER_ERROR,
  CHECK_ANSWER_LOADING,
  CHECK_ANSWER_SUCCESS,
  GET_HOME_BANNER,
  GET_HOME_BANNER_ERROR,
  GET_HOME_BANNER_LOADING,
  GET_HOME_BANNER_SUCCESS,
  GET_HOME_COURSE,
  GET_HOME_COURSE_ERROR,
  GET_HOME_COURSE_LOADING,
  GET_HOME_COURSE_SUCCESS,
  GET_QUESTION_OF_THE_DAY,
  GET_QUESTION_OF_THE_DAY_ERROR,
  GET_QUESTION_OF_THE_DAY_LOADING,
  GET_QUESTION_OF_THE_DAY_SUCCESS,
} from "./constants";

export const getHomeBanner = (payload) => ({ type: GET_HOME_BANNER, payload });
export const getHomeBannerLoading = () => ({ type: GET_HOME_BANNER_LOADING });
export const getHomeBannerSuccess = (payload) => ({
  type: GET_HOME_BANNER_SUCCESS,
  payload,
});
export const getHomeBannerError = (payload) => ({
  type: GET_HOME_BANNER_ERROR,
  payload,
});

export const getHomeCourse = (payload) => ({ type: GET_HOME_COURSE, payload });
export const getHomeCourseLoading = () => ({ type: GET_HOME_COURSE_LOADING });
export const getHomeCourseSuccess = (payload) => ({
  type: GET_HOME_COURSE_SUCCESS,
  payload,
});
export const getHomeCourseError = (payload) => ({
  type: GET_HOME_COURSE_ERROR,
  payload,
});

export const getQuestionOfTheDay = (payload) => ({
  type: GET_QUESTION_OF_THE_DAY,
  payload,
});
export const getQuestionOfTheDayLoading = () => ({
  type: GET_QUESTION_OF_THE_DAY_LOADING,
});
export const getQuestionOfTheDayError = (payload) => ({
  type: GET_QUESTION_OF_THE_DAY_ERROR,
  payload,
});
export const getQuestionOfTheDaySuccess = (payload) => ({
  type: GET_QUESTION_OF_THE_DAY_SUCCESS,
  payload,
});

export const checkAlreadyAnswer = (payload) => ({
  type: CHECK_ALREADY_ANSWERED,
  payload,
});
export const checkAlreadyAnswerSuccess = (payload) => ({
  type: CHECK_ALREADY_ANSWERED_SUCCESS,
  payload,
});
export const checkAlreadyAnswerError = (payload) => ({
  type: CHECK_ALREADY_ANSWERED_ERROR,
  payload,
});
export const checkAlreadyAnswerClear=()=>({
  type:CHECK_ALREADY_ANSWERED_CLEAR
})

export const checkAnswer = (payload) => ({ type: CHECK_ANSWER, payload });
export const checkAnswerLoading = () => ({ type: CHECK_ANSWER_LOADING });
export const checkAnswerSuccess = (payload) => ({
  type: CHECK_ANSWER_SUCCESS,
  payload,
});
export const checkAnswerError = (payload) => ({
  type: CHECK_ANSWER_ERROR,
  payload,
});
